module.exports = __webpack_public_path__ + "img/media.91622d3f.png";